import { appUserContext } from "helpers/services";
import { useContext, useState } from "react";
import { CircularProgress, Link as MuiLink } from "@material-ui/core";
import { ticketsContext } from "../TicketsContext";
import axios from "axios";


let ExcelExport = () => {
    let { currentUser } = useContext(appUserContext);
    let { recordCount, lastExecutedSearch, queue } = useContext(ticketsContext);

    let [isLoading, setIsLoading] = useState(false);


    let downloadExportedExcel = async () => {
        try {
            setIsLoading(true);
            let request = {
                ...lastExecutedSearch, 
                queue
            }

            let response = await axios.post<any>('/api/TicketExcelExport/GetExcelExport', request, { responseType: "blob" });

            let filename = ``;
            let disposition = response.headers['content-disposition'];

            if (disposition && disposition.indexOf('attachment') !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1])
                    filename = matches[1].replace(/['"]/g, '');
            }


            let url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        } catch (error) { }
        setIsLoading(false)
    }

    return (
        <>
            {currentUser?.canCreateExcelTicketExport &&
                <>
                    <MuiLink
                        disabled={isLoading}
                        component="button"
                        color="secondary"
                        variant="body2"
                        onClick={(e) => {
                            e.preventDefault()
                            if (recordCount > 400) {
                                let text = "Export will have only the first 400 claims. Do you want proceed?"
                                if (window.confirm(text)) {
                                    downloadExportedExcel()
                                }
                            } else {
                                downloadExportedExcel()
                            }
                        }}
                    >
                        Excel Export
                    </MuiLink>
                    &nbsp;&nbsp;
                    {isLoading && <CircularProgress size={10} />}
                </>
            }
        </>
    )
}

export default ExcelExport;